module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/logo-american-apparel-e510d17d41a6d6da09dd437fe284b935.png";